'use client';

import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Stack } from '@andritzot/metris-web-ui/layout/stack';
import { type ReactNode } from 'react';

interface FieldRowProps {
  label: string;
  children: ReactNode;
}

export function FieldRow({ label, children }: Readonly<FieldRowProps>) {
  return (
    <Stack direction="row" spacing={1} sx={{ py: 0.75, width: '100%' }}>
      <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 160, color: 'text.secondary' }}>
        {label}
      </Typography>
      <Box sx={{ flex: 1 }}>{children}</Box>
    </Stack>
  );
}
